import { Component, OnInit } from '@angular/core';
import text from '../../assets/textos.json';

@Component({
  selector: 'app-module5',
  templateUrl: './module5.component.html',
  styleUrls: ['./module5.component.css']
})
export class Module5Component implements OnInit {

  pageText;
  constructor()
  {
    this.pageText = text;
  }

  ngOnInit() {
  }

  slideConfig = {
    "slidesToShow": 3, 
    "slidesToScroll": 1,
    "autoplay": false,
    "dots":true,
    "infinite": false,  
    "arrows": false,
    responsive: [
      {
        breakpoint: 1120,
        settings: {
          slidesToShow: 2
        }        
      },
      {
        breakpoint: 770,
        settings: {
          slidesToShow: 1
        } 
      }     
    ]
  };
  
  slickInit(e) {
    console.log('slick initialized');
  }
  
  breakpoint(e) {
    console.log('breakpoint');
  }
  
  afterChange(e) {
    console.log('afterChange');
  }
  
  beforeChange(e) {
    console.log('beforeChange');
  }

}
